module.exports = __webpack_public_path__ + "img/pwa_install_screen_context.71ad3dc9.png";